// Add your custom JS here.

jQuery(document).ready(function($){


    $('.offcanvas .dropdown-menu').on('click', function(){
      if ($('.offcanvas').hasClass('show')){
      $('.offcanvas').removeClass('show').attr('aria-modal', false);
      $('.offcanvas-backdrop').remove();
      $('body').removeAttr( 'style' );
    }
      });
  
      
      
      

$('.slider').slick({
    centerMode: true,
    arrows: false,
    slidesToShow: 3,
    autoplay:true,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });


  $('#gallery-logo').removeClass('wp-block-gallery').removeClass('columns-1').slick({
    centerMode: true,
    arrows: false,
    slidesToShow: 5,
    autoplay:true,
    autoplaySpeed:2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
 
  
  $('#pagetop').hide();
  
  $('#pagetop').click(function () {
      $('body,html').animate({ scrollTop: 0 }, 1000);
      return false;
  });
  
  var height = $(window).height();
  $(window).scroll(function (){
      if( $(window).scrollTop() > height ){
          $('#pagetop').fadeIn();
      }else{
          $('#pagetop').fadeOut();
      }
  });
});